import React, { FormEvent } from 'react'
import { useForm, Link } from '@inertiajs/react'
import TextField from '@mui/material/TextField'
import Button from '@mui/material/Button'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { AuthLayout } from '@/components/layouts/AuthLayout'

export default function ForgotPassword() {
  const { data, setData, post, processing } = useForm({
    agent: {
      email: '',
    },
  })

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    post('/agents/password')
  }

  return (
    <AuthLayout title="Forgot your password?">
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        Enter your email address and we&apos;ll send you a link to reset your password.
      </Typography>
      <Box component="form" onSubmit={handleSubmit} noValidate>
        <TextField
          label="Email"
          type="email"
          fullWidth
          autoFocus
          autoComplete="email"
          value={data.agent.email}
          onChange={e => setData('agent', { ...data.agent, email: e.target.value })}
          sx={{ mb: 3 }}
        />
        <Button
          type="submit"
          variant="contained"
          fullWidth
          size="large"
          disabled={processing}
          sx={{ mb: 2 }}
        >
          Send reset instructions
        </Button>
        <Box sx={{ textAlign: 'center' }}>
          <Typography variant="body2" color="text.secondary">
            Remember your password?{' '}
            <Link href="/agents/sign_in" style={{ color: '#1a1a1a' }}>Sign in</Link>
          </Typography>
        </Box>
      </Box>
    </AuthLayout>
  )
}
